import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dcd001ac&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcd001ac')) {
      api.createRecord('dcd001ac', component.options)
    } else {
      api.reload('dcd001ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dcd001ac&", function () {
      api.rerender('dcd001ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/gainAdv/index.vue"
export default component.exports